import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Stock from './pages/Stock';
import VehicleAdd from './pages/VehicleAdd';
import VehicleDetail from './pages/VehicleDetail';
import Settings from './pages/Settings';
import Admin from './pages/Admin';
import Marketplace from './pages/Marketplace';
import MarketplaceConversion from './pages/MarketplaceConversion';
import MyMarketplaceListings from './pages/MyMarketplaceListings';
import MarketplaceListingDetail from './pages/MarketplaceListingDetail';
import MyOffers from './pages/MyOffers';
import MyAppointments from './pages/MyAppointments';
import ProtectedRoute from './components/ProtectedRoute';
import Activity from './pages/Activity';
import Website from './pages/Website';
import Social from './pages/Social';
import LandingPage from './pages/LandingPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Search from './pages/Search';
import Opportunities from './pages/Opportunities';
import OpportunitiesConversion from './pages/OpportunitiesConversion';
import Deals from './pages/Deals';
import Market from './pages/Market';

// Gate: show conversion page for non-approved users, real marketplace for approved
const MarketplaceGate = () => {
  const { user } = useAuth();
  const isApproved = user?.marketplace_approved === true || user?.marketplace_status === 'approved';
  return isApproved ? <Marketplace /> : <MarketplaceConversion />;
};

// Gate: show conversion page for non-activated users, real opportunities for activated
const OpportunitiesGate = () => {
  const { user } = useAuth();
  const isActive = user?.opportunities_status === 'active';
  return isActive ? <Opportunities /> : <OpportunitiesConversion />;
};

function App() {
  return (
    <ThemeProvider>
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/landing" element={<LandingPage />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/search" element={<ProtectedRoute><Search /></ProtectedRoute>} />
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="stock" element={<Stock />} />
            <Route path="vehicles/add" element={<VehicleAdd />} />
            <Route path="vehicles/:id" element={<VehicleDetail />} />
            <Route path="marketplace" element={<MarketplaceGate />} />
            <Route path="marketplace/my-listings" element={<MyMarketplaceListings />} />
            <Route path="marketplace/offers" element={<MyOffers />} />
            <Route path="marketplace/appointments" element={<MyAppointments />} />
            <Route path="marketplace/:id" element={<MarketplaceListingDetail />} />
            {/* Redirect old /connections to settings with social tab */}
            <Route path="connections" element={<Navigate to="/settings?tab=social" replace />} />
            <Route path="website" element={<Website />} />
            <Route path="social" element={<Social />} />
            <Route path="opportunities" element={<OpportunitiesGate />} />
            <Route path="deals" element={<Deals />} />
            <Route path="market" element={<Market />} />
            <Route path="activity" element={<Activity />} />
            <Route path="settings" element={<Settings />} />
            <Route path="admin" element={<Admin />} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
